import { Component, OnInit } from '@angular/core';
import { HttpRequestService } from 'src/app/_services/http-request.service';
import { CurrentPortfolio } from 'src/app/_models/current-portfolio';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-current-portfolio',
  templateUrl: './current-portfolio.component.html',
  styleUrls: ['./current-portfolio.component.css']
})
export class CurrentPortfolioComponent implements OnInit {

  currentPortfolio: CurrentPortfolio[] = [];
  allPositionsValueConverted: number = 0;

  constructor(private httpRequestService: HttpRequestService) { }

  ngOnInit() {
    this.getCurrentPortfolio();
  }

  getCurrentPortfolio() {
    return this.httpRequestService.currentPortfolioData.pipe(tap(responseData => {
      this.resetValues();
      if (responseData.length === 0)
        return;
      this.currentPortfolio = responseData;
      this.computeMovementsAndTotalValue();
    })).toPromise();
  }

  computeMovementsAndTotalValue() {
    this.currentPortfolio.forEach(element => {
      // Calculate the absolute value of the price movement compared to the open price (in percentage)
      element.percentageMovement = Math.abs((element.markPrice - element.openPrice) / element.openPrice * 100);
      // Set to true if the percentage movement is UP and false for DOWN
      element.isPercentageMovementUp = ((element.openPrice < element.markPrice && element.quantity > 0) || (element.openPrice > element.markPrice && element.quantity < 0));
      // Sum of all the positions in the base currency of the account
      this.allPositionsValueConverted += element.positionValueConverted;
    });
  }

  resetValues() {
    this.allPositionsValueConverted = 0;
    this.currentPortfolio = [];
  }
}
